/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/betting-cancel.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const ChatPenaltyInfo: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      채팅을 반복해서 입력하면<br/>
      <span className="point-color--orange--modal">도배로 간주될 수 있습니다.</span>

    </p>
  )
  const body = (
    <div className="guide-box small">
      계속될 경우 채팅 이용이 <span className="point-color--orange--modal">제한</span>됩니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
